import {FormSection} from '@/components/commons/form-section/FormSection'
import {PatientAgeServiceType} from '@/components/commons/patient-age-service-type/PatientAgeServiceType'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {FemaleIcon, MaleIcon} from '@/components/ui/icon/Icon'
import {PatientExtended} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'
import {useOutletContext} from 'react-router-dom'
import {useTheme} from 'styled-components'
import {Text} from '@/components/ui/text/Text'

export const MedicalReportPatientSection = () => {
    const {t} = useTranslation()

    return (
        <FormSection title={t('commons:patient')} hasBottomDivider>
            <Grid columns={3}>
                <GridItem spanColumn={2}>
                    <MedicalReportPatientCard />
                </GridItem>
            </Grid>
        </FormSection>
    )
}

const MedicalReportPatientCard = () => {
    const {t} = useTranslation()
    const {palette} = useTheme()
    const {patient} = useOutletContext<{patient: PatientExtended}>()

    return (
        <FormCardSection columnGap={4.5} columns={2} padding={3}>
            <GridItem spanColumn={1}>
                <Flexbox direction="column" gap={2}>
                    <Flexbox gap={2}>
                        <Text weight="500" size="textMd">
                            {patient.fullName}
                        </Text>
                        {patient.gender == 'male' && <MaleIcon size={18} color={palette.primary[600]} />}
                        {patient.gender == 'female' && <FemaleIcon size={18} color={palette.purple[600]} />}
                    </Flexbox>
                    <Flexbox direction="column">
                        <Text size="textSm" palette="neutral" shade="500">
                            {t('commons:residence_asl')}
                        </Text>
                        <Text size="textSm" palette="neutral" shade="500">
                            {patient.residenceAslDistrict?.aslName} - {patient.residenceAslDistrict?.name}
                        </Text>
                    </Flexbox>
                </Flexbox>
            </GridItem>

            <GridItem spanColumn={1}>
                <Flexbox direction="column" gap={2}>
                    <Text weight="500" size="textMd">
                        <PatientAgeServiceType birthDate={new Date(patient.birthDate)} />
                    </Text>
                    <Flexbox direction="column">
                        <Text size="textSm" palette="neutral" shade="500">
                            {t('commons:domicile_asl')}
                        </Text>
                        <Text size="textSm">
                            {patient.domicileAslDistrict?.id === patient.residenceAslDistrict?.id ? (
                                !patient.residenceAslDistrict?.id ? (
                                    '-'
                                ) : (
                                    t('commons:same_as_residence')
                                )
                            ) : (
                                <Text size="textSm">
                                    {patient.domicileAslDistrict?.aslName} - {patient.domicileAslDistrict?.name}
                                </Text>
                            )}
                        </Text>
                    </Flexbox>
                </Flexbox>
            </GridItem>
        </FormCardSection>
    )
}
